let swiperInstance = null; // Store the current Swiper instance
// console.log('desktop');
// function destroySwiper() {
//   if (swiperInstance && typeof swiperInstance.destroy === "function") {
//     try {
//       swiperInstance.destroy(true, true); // Destroy the Swiper instance and clean up
//       swiperInstance = null;
//     } catch (error) {
//       console.error("Error destroying Swiper instance:", error);
//     }
//   }
// }

function nileShopMobileSwiperInit() {
  if (aico.jq(".mySwiper").length > 0) {
    aico.jq(".mySwiper").each(function () {
      const productCard = this.closest(".af-productCard");
      
      if (!productCard || productCard.dataset.swiperInitialized) return;
      productCard.dataset.swiperInitialized = "true";

      
      let swiper;
      let isInitializing = false;

      // Function to initialize or reinitialize Swiper with filtered slides
      const initSwiperWithColor = (color) => {
        // Destroy existing swiper if it exists
        if (swiper) {
          swiper.destroy(true, true);
        }

        // Set initialization flag
        isInitializing = true;

        // Filter slides based on color and collect visible slides
        const allSlides = productCard.querySelectorAll(".swiper-slide");
        const visibleSlides = Array.from(allSlides).filter((slide) => {
        const slideColor = slide.querySelector("img")?.getAttribute("color-title");
          slide.style.display = slideColor === color ? "block" : "none";
          return slide.style.display === "block";
        });


        // Initialize new Swiper instance
        swiper = new Swiper(productCard.querySelector(".mySwiper"), {
          loop: false,
          initialSlide: 0, // Always start at the first visible slide
          allowSlideNext: false, // Disable sliding during init
          allowSlidePrev: false, // Disable sliding during init
          autoplay: false, // Explicitly disable autoplay
          keyboard: { enabled: false }, // Disable keyboard navigation
          mousewheel: { enabled: false }, // Disable mousewheel navigation
          on: {
            init: function () {
              const swiperInstance = this;
              const swiperEl = swiperInstance.el;
              const totalSlides = visibleSlides.length;

              // Remove existing pagination
              const existingPagination = swiperEl.querySelector(".nile-ch-pagination-container");
              if (existingPagination) existingPagination.remove();

              // Create new pagination container
              const paginationContainer = document.createElement("div");
              paginationContainer.className = "nile-ch-pagination-container";

              // Create segment bars for visible slides
              for (let i = 0; i < totalSlides; i++) {
                const bar = document.createElement("div");
                bar.className = "nile-ch-bar";
                bar.dataset.index = i;
                bar.addEventListener("click", function () {
                  swiperInstance.slideTo(i); // Navigate to the i-th visible slide
                  console.log("Pagination clicked, navigating to index:", i);
                });
                paginationContainer.appendChild(bar);
              }
              swiperEl.appendChild(paginationContainer);
              swiperInstance.customPaginationBars = paginationContainer.children;

              // Update pagination after initialization
              updateCustomPagination(swiperInstance);

              // Re-enable sliding after initialization
              swiperInstance.allowSlideNext = true;
              swiperInstance.allowSlidePrev = true;
            },
            slideChange: function () {
              if (!isInitializing) {
                updateCustomPagination(this);
                // console.log("Slide changed to index:", this.activeIndex);
              } else {
                console.log("Slide change ignored during initialization, current index:", this.activeIndex);
              }
            },
          },
        });

        // Force Swiper to update slide calculations
        swiper.update();
        swiper.updateSlides();
        swiper.updateSize();
        swiper.updateSlidesProgress();

        // Ensure the first visible slide is shown
        if (visibleSlides.length > 0) {
          swiper.slideTo(0, 0); // Instant transition to the first visible slide
          updateCustomPagination(swiper); // Update pagination immediately
          // console.log("Active slide index after initialization:", swiper.activeIndex);

          // Final safeguard to ensure index 0
          setTimeout(() => {
            if (swiper.activeIndex !== 0) {
              // console.log("Correcting active index to 0, was:", swiper.activeIndex);
              swiper.slideTo(0, 0);
              updateCustomPagination(swiper);
            }
            isInitializing = false; // End initialization
            // console.log("Initialization complete, final active index:", swiper.activeIndex);
          }, 100);
        } else {
          isInitializing = false; // End initialization if no slides
        }
      };

      // Update pagination based on visible slides
      function updateCustomPagination(swiperInstance) {
        if (!swiperInstance.customPaginationBars) return; // Safeguard against undefined bars
        const bars = swiperInstance.customPaginationBars;
        const activeIndex = swiperInstance.activeIndex;

        for (let i = 0; i < bars.length; i++) {
          bars[i].classList.toggle("active", i === activeIndex);
        }
      }

      // Get initial active color
      let activeColor = productCard
        .querySelector(".af-color-options .af-active-color")
        ?.getAttribute("color-title");
      if (activeColor) {
        // activeColor = activeColor.replace(/\s+/g, '_').toLowerCase();
        initSwiperWithColor(activeColor);
      }

      // Handle color option clicks
      productCard
        .querySelectorAll(".af-color-options .color-options")
        .forEach((colorOption) => {
          colorOption.addEventListener("click", (e) => {
            let selectedColor = e.target
              .closest(".color-options")
              .getAttribute("color-title");

               if (!selectedColor) return;
            
              // Check if any slide matches the selected color
              const allSlides = productCard.querySelectorAll(".swiper-slide");
              const hasMatchingSlide = Array.from(allSlides).some((slide) => {
                const slideColor = slide.querySelector("img")?.getAttribute("color-title");
                return slideColor === selectedColor;
              });

              // Change a linke if any slide matches the selected color
              let selectedColorLink = e.target.closest(".color-options").getAttribute("color-variant-link");
              Array.from(allSlides).forEach((slide) => {
                const slideColor = slide.querySelector("img")?.getAttribute("color-title");
                if (slideColor === selectedColor) {
                  slide.querySelector("a")?.setAttribute("href", selectedColorLink);
                }
              });
        
              if (!hasMatchingSlide) {
                console.warn(`No images found for color: ${selectedColor}`);
                return; 
              }

            // Update active color class
            productCard
              .querySelectorAll(".af-color-options .color-options")
              .forEach((opt) => {
                opt.classList.remove("af-active-color");
              });
            e.target.closest(".color-options").classList.add("af-active-color");
            // selectedColor = selectedColor.replace(/\s+/g, '_').toLowerCase();

            // Reinitialize swiper with new color
            initSwiperWithColor(selectedColor);
          });
          
        });
    });
  } else {
    console.log("not found mySwiper class");
  }
}

function initDesktopSwiper() {
  if (window.innerWidth > 1024) {
    // nileShopSwiperInit();
    // CHANGE HERE
    /*setTimeout(()=>{
      loadNileDesktopSwiper();
      // console.log('dddd');
    },1000);*/
    requestAnimationFrame(() => {
      loadNileDesktopSwiper();
    });
    restoreOriginalStructure();
  }
}

function initMobileSwiper() {
  if (window.innerWidth <= 1024) {
    nileShopMobileSwiperInit();
    // CHANGE HERE 
    /*setTimeout(()=>{
        initializeColorVariants();
        reorganizeSizeOptions();
     },1000);*/
     requestAnimationFrame(() => {
      initializeColorVariants();
      reorganizeSizeOptions();
    });
  }
}

function nileShopSwiperInit() {
  if ($(".mySwiper").length > 0) {
    
    var swiper = new Swiper(".mySwiper", {
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      on: {
        init: function () {
          var swiperInstance = this;
          if (swiperInstance.slides && swiperInstance.slides.length > 0) {
            aico
              .jq(".swiper-button-prev")
              .addClass("swiper-button-disabled")
              .attr("disabled", true);
          } else {
            // console.error("Swiper slides are not available.");
          }
        },
        slideChange: function () {
          var swiperInstance = this;
          var prevButton = aico.jq(".swiper-button-prev");
          var nextButton = aico.jq(".swiper-button-next");
          if (swiperInstance.slides && swiperInstance.slides.length > 0) {
            if (swiperInstance.activeIndex === 0) {
              prevButton.addClass("swiper-button-disabled");
              prevButton.attr("disabled", true);
            } else {
              prevButton.removeClass("swiper-button-disabled");
              prevButton.removeAttr("disabled");
            }
            if (
              swiperInstance.activeIndex ===
              swiperInstance.slides.length - 1
            ) {
              nextButton.addClass("swiper-button-disabled");
              nextButton.attr("disabled", true);
            } else {
              nextButton.removeClass("swiper-button-disabled");
              nextButton.removeAttr("disabled");
            }
          } else {
            console.error("Swiper slides length is not available.");
          }
        },
      },
    });

    
  }
}

window.addEventListener("resize", () => {
  initDesktopSwiper();
  initMobileSwiper();
});


function checkProductVisibility(metafields) {
  const todayUTC = new Date(new Date().toISOString()); // Current time in UTC
  let startDate = null;
  let endDate = null;
  let isVisible = true;

  // Find metafields
  const startDateMetafield = metafields?.find(
    (mf) => mf.namespace === "aico" && mf.key === "release_start_time"
  );
  const endDateMetafield = metafields?.find(
    (mf) => mf.namespace === "aico" && mf.key === "release_end_time"
  );

  // Safely parse dates (handle invalid formats)
  function parseDate(dateString) {
    if (!dateString) return null;

    // Try parsing as ISO string (with 'Z' or '+00:00')
    let date = new Date(dateString);
    if (!isNaN(date.getTime())) return date;

    // Try forcing UTC if missing timezone
    if (!dateString.endsWith("Z") && !dateString.includes("+")) {
      date = new Date(dateString + "Z");
      if (!isNaN(date.getTime())) return date;
    }

    console.error("Invalid date format:", dateString);
    return null;
  }

  if (startDateMetafield?.value) {
    startDate = parseDate(startDateMetafield.value);
  }
  if (endDateMetafield?.value) {
    endDate = parseDate(endDateMetafield.value);
  }

  // console.log("startDate (UTC)", startDate);
  // console.log("endDate (UTC)", endDate);
  // console.log("today (UTC)", todayUTC);

  // Apply visibility logic
  // if (startDate && startDate > todayUTC) {
  //   isVisible = false; // Start date is in the future → hide
  // }
  // if (endDate && endDate <= todayUTC) {
  //   isVisible = false; // End date is today or in the past → hide
  // }

  // console.log("isVisible", isVisible);
  return isVisible;
}



const slideDataCache = new Map();

function loadNileDesktopSwiper(container = document) {
  // ---------- helpers ----------
  function normalizeColor(s) {
    return (s || "")
      .replace(/[.\_\-]+/g, " ")   // replace dot, underscore, hyphen with space
      .replace(/\s+/g, " ")        // collapse multiple spaces
      .trim()
      .toLowerCase()
      .replace(/\d+$/, "")         // remove trailing numbers like "1", "2"
      .trim();
  }

  function inferColorFromSrc(src) {
    if (!src) return "";
    // Strip query string & extension
    const file = src.split("/").pop().split("?")[0];
    const base = file.replace(/\.[^.]+$/, ""); // no extension
    // Take text between first and last underscore: H25252_<COLOR>_1  -> <COLOR>
    const first = base.indexOf("_");
    const last = base.lastIndexOf("_");
    if (first !== -1 && last !== -1 && last > first) {
      const slug = base.slice(first + 1, last);
      return normalizeColor(slug);
    }
    return "";
  }

  function getStableCardId(productCard) {
    // let id = productCard.dataset.variantId || productCard.dataset.handle || productCard.id;
    // if (!id) {
    //   id = `card-${Math.random().toString(36).substr(2, 9)}`;
    //   productCard.dataset.productId = id; // persist so it stays stable
    // } else if (!productCard.dataset.productId) {
    //   productCard.dataset.productId = id; // ensure dataset holds the chosen stable id
    // }
    return productCard.dataset.variantId;
  }

  function buildSlidesFromDOM(productCard, selectedColorLink=null) {
    return Array.from(productCard.querySelectorAll(".swiper-slide")).map((slide) => {

      const img = slide.querySelector("img");
      const declared =
        slide.getAttribute("color-title") ||
        slide.dataset.colorTitle ||
        img?.getAttribute("color-title") ||
        img?.dataset.colorTitle ||
        "";

      const src = img?.getAttribute("src") || "";
      const inferred = inferColorFromSrc(src);

      // Prefer inferred (from filename) when present; it fixes the blue_denim mismatch.
      const chosen = inferred || normalizeColor(declared);
      return {
        image_id: slide.getAttribute("image-id"),
        color_key: chosen,                     // normalized for matching
        color_title: chosen,                   // use normalized as label for consistency
        src,
        alt: img?.getAttribute("alt") || "",
        href: (selectedColorLink)?selectedColorLink : slide.querySelector("a")?.getAttribute("href") || "#",
      };
    });
  }

  function updateNavigationButtons(swiper, totalSlides) {
    const nextButton = swiper.el.querySelector(".swiper-button-next");
    const prevButton = swiper.el.querySelector(".swiper-button-prev");

    if (prevButton) {
      if (swiper.activeIndex === 0 || totalSlides <= 1) {
        prevButton.classList.add("swiper-button-disabled");
        prevButton.setAttribute("aria-disabled", "true");
        prevButton.setAttribute("tabindex", "-1");
        prevButton.setAttribute("disabled", "disabled");
      } else {
        prevButton.classList.remove("swiper-button-disabled");
        prevButton.setAttribute("aria-disabled", "false");
        prevButton.setAttribute("tabindex", "0");
        prevButton.removeAttribute("disabled");
      }
    }

    if (nextButton) {
      if (swiper.activeIndex === totalSlides - 1 || totalSlides <= 1) {
        nextButton.classList.add("swiper-button-disabled");
        nextButton.setAttribute("aria-disabled", "true");
        nextButton.setAttribute("tabindex", "-1");
        nextButton.setAttribute("disabled", "disabled");
      } else {
        nextButton.classList.remove("swiper-button-disabled");
        nextButton.setAttribute("aria-disabled", "false");
        nextButton.setAttribute("tabindex", "0");
        nextButton.removeAttribute("disabled");
      }
    }
  }

  // ---------- core ----------
  function initializeSwiper(productCard, selectedColor, selectedColorLink=null) {
    const swiperContainer = productCard.querySelector(".mySwiper");
    const swiperWrapper = swiperContainer.querySelector(".swiper-wrapper");
    const nextButton = productCard.querySelector(".swiper-button-next");
    const prevButton = productCard.querySelector(".swiper-button-prev");

    const productCardId = getStableCardId(productCard);

    // Build cache once (from original DOM), then only read from cache
    let allSlides = slideDataCache.get(productCardId);
    if (!allSlides) {
      allSlides = buildSlidesFromDOM(productCard, selectedColorLink);
      slideDataCache.set(productCardId, allSlides);
    }

    const wantedKey = normalizeColor(selectedColor);
    let filteredSlides = allSlides.filter((s) => s.color_key === wantedKey);

    // Fallbacks: try looser match; finally show all to avoid empty slider
    if (filteredSlides.length === 0) {
      const compactWanted = wantedKey.replace(/\s+/g, "");
      filteredSlides = allSlides.filter((s) => {
        const compactKey = s.color_key.replace(/\s+/g, "");
        return compactKey === compactWanted || s.src.toLowerCase().includes(compactWanted);
      });
    }
    if (filteredSlides.length === 0) filteredSlides = allSlides;

    // Rebuild slides
    swiperWrapper.innerHTML = "";
    filteredSlides.forEach((slide, index) => {
      const el = document.createElement("div");
      el.classList.add("swiper-slide");
      el.setAttribute("image-id", slide.image_id);
      el.setAttribute("role", "group");
      el.setAttribute("aria-label", `${index + 1} / ${filteredSlides.length}`);
      el.style.width = "305px";
      el.innerHTML = `
        <a href="${slide.href}">
          <img color-title="${slide.color_title}" src="${slide.src}" alt="${slide.alt}" onerror="this.src='https://cdn.shopify.com/s/files/1/0865/6692/8715/files/product-placeholder.jpg?v=1755017199&width=990'">
        </a>
      `;
      swiperWrapper.appendChild(el);
    });

    // Reset Swiper
    if (swiperContainer.swiper) {
      swiperContainer.swiper.destroy(true, true);
    }

    // Toggle nav
    const multiple = filteredSlides.length > 1;
    if (nextButton) nextButton.style.display = multiple ? "block" : "none";
    if (prevButton) prevButton.style.display = multiple ? "block" : "none";

    // Init Swiper
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: nextButton || null,
        prevEl: prevButton || null,
        disabledClass: "swiper-button-disabled",
      },
      on: {
        init() {
          updateNavigationButtons(this, filteredSlides.length);
        },
        slideChange() {
          updateNavigationButtons(this, filteredSlides.length);
        },
      },
    });

    swiperWrapper.setAttribute("aria-live", "polite");
    swiperWrapper.setAttribute("id", `swiper-wrapper-${Math.random().toString(36).substr(2, 9)}`);
    if(selectedColorLink) {
      const links = swiperWrapper.querySelectorAll('a');
      // Replace href for each <a> tag
      links.forEach(link => {
          link.href = selectedColorLink;
      });
    }
    swiperContainer.swiper = swiper;
    updateNavigationButtons(swiper, filteredSlides.length);
  }

  // ---------- boot ----------
  container.querySelectorAll(".af-productCard").forEach((productCard) => {

    if (productCard.dataset.swiperInitialized) return;

    
    productCard.dataset.swiperInitialized = "true";
    // Pre-cache original slides before we ever clear the wrapper
    const productCardId = getStableCardId(productCard);
    if (!slideDataCache.get(productCardId)) {
      slideDataCache.set(productCardId, buildSlidesFromDOM(productCard));
    }
    

    // Initial color
    const activeColor = productCard
      .querySelector(".af-color-options .af-active-color")
      ?.getAttribute("color-title");
    if (activeColor) {
      initializeSwiper(productCard, activeColor);
    }

    // Color switch
    productCard.querySelectorAll(".af-color-options .color-options").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        const selectedColor = e.currentTarget.getAttribute("color-title");
        const selectedColorLink = e.currentTarget.getAttribute("color-variant-link");
        if (!selectedColor) return;

        // Only proceed if we actually have slides for this color (after normalization)
        const key = normalizeColor(selectedColor);
        const allSlides = slideDataCache.get(productCardId) || [];
        const hasAny = allSlides.some((s) => s.color_key === key) ||
                       allSlides.some((s) => s.src.toLowerCase().includes(key.replace(/\s+/g, "_")));

        if (!hasAny) {
          console.warn("No matching images for selected color:", selectedColor);
          return;
        }

        // Update active class
        productCard
          .querySelectorAll(".af-color-options .color-options")
          .forEach((opt) => opt.classList.remove("af-active-color"));
        e.currentTarget.classList.add("af-active-color");

        initializeSwiper(productCard, selectedColor,selectedColorLink);
      });
    });
  });
}


function initializeColorVariants() {
  document.querySelectorAll(".af-productCard").forEach((productCard) => {
    // Get all color option containers within the product card
    const colorOptionContainers = productCard.querySelectorAll(".af-color-options");
    const maxDefaultVariants = 4;

    colorOptionContainers.forEach((colorOptionContainer) => {
      const colorOptions = colorOptionContainer.querySelectorAll(".color-options");
      let additionalVariants = colorOptionContainer.querySelector(".additional-variants");
      let isHidden = true; // State per colorOptionContainer

      // Create and append additional-variants span if it doesn't exist
      if (!additionalVariants) {
        additionalVariants = document.createElement("span");
        additionalVariants.className = "additional-variants";
        colorOptionContainer.appendChild(additionalVariants);
      }

      if (colorOptions.length > maxDefaultVariants) {
        // Initially hide extra variants
        colorOptions.forEach((option, index) => {
          if (index >= maxDefaultVariants) {
            option.style.display = "none";
          }
        });
        additionalVariants.textContent = `+${colorOptions.length - maxDefaultVariants}`;
        additionalVariants.style.display = "inline";

        // Remove existing event listeners to prevent duplicates
        const newAdditionalVariants = additionalVariants.cloneNode(true);
        additionalVariants.parentNode.replaceChild(newAdditionalVariants, additionalVariants);
        additionalVariants = newAdditionalVariants;

        // Add single click event listener
        additionalVariants.addEventListener("click", () => {
          // console.log("additional variant clicked, isHidden:", isHidden);

          colorOptions.forEach((option, index) => {
            if (index >= maxDefaultVariants) {
              option.style.setProperty("display", isHidden ? "flex" : "none", "important");
            }
          });

          // Update text and state
          additionalVariants.textContent = isHidden
            ? `-${colorOptions.length - maxDefaultVariants}`
            : `+${colorOptions.length - maxDefaultVariants}`;
          isHidden = !isHidden;
        });
      } else {
        additionalVariants.style.display = "none";
      }
    });
  });
}

// Store the original HTML globally
let originalSizeWidgetContent = null;

function reorganizeSizeOptions() {
    // console.log("reorganizeSizeOptions");
    const container = document.querySelector('.aico-product-options');
    if (!container) {
        return; // exit the function if container is not present
    }

    const sizeContainer = container.querySelector('.af-filter-size');
    const sizeList = sizeContainer?.querySelector('.af-widgetCheck');
    const sizeWidgetContent = sizeContainer?.querySelector('.af-widgetContent');
    const newSections = {
        schuhe: [],
        accessories: []
    };

    if (!sizeList) return;

    // Store the original HTML of af-widgetContent before any modifications
    if (!originalSizeWidgetContent) {
        originalSizeWidgetContent = sizeWidgetContent.innerHTML;
        // console.log(originalSizeWidgetContent,'container');
    }

     // Create a new parent div for .af-widgetCheck if it doesn't already have the desired parent
    if (sizeList && !sizeList.parentNode.classList.contains('af-size-filter-wrapper')) {
        const parentDiv = document.createElement('div');
        parentDiv.className = 'af-size-filter-wrapper';
        sizeList.parentNode.insertBefore(parentDiv, sizeList);
        parentDiv.appendChild(sizeList); // Move sizeList into the new parent div
    }

    sizeList.querySelectorAll('li').forEach(item => {
        const value = item.querySelector('input').value;
        const isNumeric = /^\d+$/.test(value);
        const isCm = /cm$/.test(value);
        // console.log(value, isNumeric, isCm);

        if (isNumeric) {
            newSections.schuhe.push(item);
        } else if (isCm) {
            newSections.accessories.push(item);
        }
    });

  
    // Create Schuhe section
    if (newSections.schuhe.length > 0) {
        const schuheDiv = document.createElement('div');
        schuheDiv.className = 'af-number-filter-size af-size-filter-wrapper';
        let sizeTitle = 'Shoes';
        if (Shopify.locale === 'de') {
          sizeTitle = 'Schuhe';
        } else if (Shopify.locale === 'fr') {
          sizeTitle = 'Chaussures';
        } else if (Shopify.locale === 'it') {
          sizeTitle = 'Scarpe';
        } else {
          sizeTitle = 'Shoes'; // Default (English)
        }


        schuheDiv.innerHTML = `
            <div class="af-number-title-wrapper">
                <span class="af-size-title">${sizeTitle}</span>
            </div>
            <div class="af-widgetContent">
                <ul class="af-widgetCheck af-multiple"></ul>
            </div>
        `;
        const schuheList = schuheDiv.querySelector('ul');
        newSections.schuhe.forEach(item => schuheList.appendChild(item));
        sizeWidgetContent.appendChild(schuheDiv);
    }

    // Create Accessories section
    if (newSections.accessories.length > 0) {
        const accessoriesDiv = document.createElement('div');
        accessoriesDiv.className = 'af-filter-accessories';
        let sizeTitleAs = 'Accessories';
        if (Shopify.locale === 'de') {
          sizeTitleAs = 'Accessories';
        } else if (Shopify.locale === 'fr') {
          sizeTitleAs = 'Accessoires';
        } else if (Shopify.locale === 'it') {
          sizeTitleAs = 'Accessori';
        } else {
          sizeTitleAs = 'Accessories'; // Default (English)
        }
        accessoriesDiv.innerHTML = `
           <div>
                <span class="af-size-title">${sizeTitleAs}</span>
            </div>
            <div class="af-widgetContent">
                <ul class="af-widgetCheck af-multiple"></ul>
            </div>
        `;
        const accessoriesList = accessoriesDiv.querySelector('ul');
        newSections.accessories.forEach(item => accessoriesList.appendChild(item));
        sizeWidgetContent.appendChild(accessoriesDiv);
    }

    // Remove original items from Grösse section
     newSections.schuhe.forEach(item => {
        if (sizeList && sizeList.contains(item)) {
            sizeList.removeChild(item);
        } else {
            // console.warn('Item is not a child of sizeList:', item);
        }
    });
    newSections.accessories.forEach(item => {
        if (sizeList && sizeList.contains(item)) {
            sizeList.removeChild(item);
        } else {
            // console.warn('Item is not a child of sizeList:', item);
        }
    });

  if (sizeContainer instanceof HTMLElement && sizeList instanceof HTMLElement) {
        const existingTitle = sizeContainer.querySelector('.af-title');
        const sizeFilterWrapper = sizeList.parentNode.classList.contains('af-size-filter-wrapper') 
            ? sizeList.parentNode 
            : null;

        if (sizeFilterWrapper && sizeList.querySelectorAll('li').length > 0 && !existingTitle) {
            // Create and append the Kleidung div before af-size-filter-wrapper
            const kleidungDiv = document.createElement('div');
            kleidungDiv.className = 'af-title';
            const kleidungSpan = document.createElement('span');
            if (Shopify.locale === 'de') {
              kleidungSpan.textContent = 'Kleidung';
            } else if (Shopify.locale === 'fr') {
              kleidungSpan.textContent = 'Vêtements';
            } else if (Shopify.locale === 'it') {
              kleidungSpan.textContent = 'Abbigliamento';
            } else {
              kleidungSpan.textContent = 'Clothing';
            }
            kleidungDiv.appendChild(kleidungSpan);

            // Insert kleidungDiv before af-size-filter-wrapper
            if (sizeFilterWrapper.parentNode) {
                sizeFilterWrapper.parentNode.insertBefore(kleidungDiv, sizeFilterWrapper);
            } else {
                console.error('sizeFilterWrapper has no parentNode, cannot insert kleidungDiv');
            }
        } else if (sizeFilterWrapper && sizeList.querySelectorAll('li').length === 0 && existingTitle) {
            // Remove the existing af-title if ul inside af-size-filter-wrapper is empty
            existingTitle.remove();
        }
    } else {
        console.error('sizeContainer or sizeList is not a valid DOM element');
    }
}
// Store the original HTML globally (assumed to be defined elsewhere)

// Store checkbox states globally to persist across function calls
let checkboxStates = new Map();

function restoreOriginalStructure() {
    const container = document.querySelector('.aico-product-options');
    if (!container) {
        console.warn('Container .aico-product-options not found');
        return;
    }

    const sizeContainer = container.querySelector('.af-filter-size');
    const sizeWidgetContent = sizeContainer?.querySelector('.af-widgetContent');

    if (sizeWidgetContent && originalSizeWidgetContent) {
        // Store the checked states of checkboxes before restoring
        sizeWidgetContent.querySelectorAll('input[type="checkbox"]').forEach(input => {
            checkboxStates.set(input.id, input.checked);
        });

        // Restore the original HTML
        sizeWidgetContent.innerHTML = originalSizeWidgetContent;
        console.log('Restored original HTML');

        // Ensure the af-widgetCheck is directly under af-widgetContent (remove af-size-filter-wrapper if it exists)
        const sizeList = sizeWidgetContent.querySelector('.af-widgetCheck');
        const sizeFilterWrapper = sizeList?.parentNode.classList.contains('af-size-filter-wrapper') 
            ? sizeList.parentNode 
            : null;
        if (sizeFilterWrapper && sizeList && sizeList.parentNode !== sizeWidgetContent) {
            sizeWidgetContent.appendChild(sizeList); // Move sizeList back to af-widgetContent
            sizeFilterWrapper.remove(); // Remove the wrapper
            console.log('Removed af-size-filter-wrapper');
        }

        // Reapply checked states after restoration
        sizeWidgetContent.querySelectorAll('input[type="checkbox"]').forEach(input => {
            if (checkboxStates.has(input.id)) {
                input.checked = checkboxStates.get(input.id);
            }
        });

        // Add event listeners to lock checkbox states and prevent external resets
        sizeWidgetContent.querySelectorAll('input[type="checkbox"]').forEach(input => {
            // Remove existing listeners by cloning to prevent conflicts
            const newInput = input.cloneNode(true);
            input.replaceWith(newInput);

            // Update checkboxStates on user interaction
            newInput.addEventListener('change', () => {
                checkboxStates.set(newInput.id, newInput.checked);
                console.log(`Checkbox ${newInput.id} changed to ${newInput.checked}`);
                // Check after 2 seconds to catch delayed resets
                setTimeout(() => {
                    if (checkboxStates.has(newInput.id) && newInput.checked !== checkboxStates.get(newInput.id)) {
                        console.warn(`Checkbox ${newInput.id} unexpectedly changed to ${newInput.checked}; restoring to ${checkboxStates.get(newInput.id)}`);
                        newInput.checked = checkboxStates.get(newInput.id);
                    }
                }, 2000);
            });
        });
    }
}

function handleClearFilters(event) {
    const clearButton = event.target.closest('.aico-filter-clear');
    if (!clearButton) {
        console.warn('No valid .aico-filter-clear element found');
        return;
    }

    const refineItem = clearButton.closest('.refine-by-item');
    if (!refineItem || !refineItem.querySelector('[data-filter-key="aico_option_size"]')) {
        console.log('Clear button not for size filter; skipping operation');
        return;
    }

    // Check if the clear button is specifically within the size filter context
    const sizeFilterContainer = clearButton.closest('.aico-filters')?.querySelector('.aico-product-options');
    if (!sizeFilterContainer) {
        console.log('Clear button not within size filter context; skipping operation');
        return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    console.log(urlParams, 'urlParams');
    if (!urlParams.has('aico_option_size')) {
        console.log('No aico_option_size parameters in URL; skipping clear operation');
        return;
    }

    const sizeWidgetContent = sizeFilterContainer.querySelector('.af-widgetContent');
    if (!sizeWidgetContent) {
        console.warn('sizeWidgetContent not found for clear');
        return;
    }

    // Uncheck only size-related checkboxes and update checkboxStates
    sizeWidgetContent.querySelectorAll('input[type="checkbox"][name="aico_option"]').forEach(input => {
        input.checked = false;
        checkboxStates.set(input.id, false);
    });
    console.log('Cleared size-related checkboxes');

    // Reattach event listeners to ensure state locking for size checkboxes
    sizeWidgetContent.querySelectorAll('input[type="checkbox"][name="aico_option"]').forEach(input => {
        const newInput = input.cloneNode(true);
        input.replaceWith(newInput);
        newInput.addEventListener('change', () => {
            checkboxStates.set(newInput.id, newInput.checked);
            console.log(`Checkbox ${newInput.id} changed to ${newInput.checked}`);
            setTimeout(() => {
                if (checkboxStates.has(newInput.id) && newInput.checked !== checkboxStates.get(newInput.id)) {
                    console.warn(`Checkbox ${newInput.id} unexpectedly changed to ${newInput.checked}; restoring to ${checkboxStates.get(newInput.id)}`);
                    newInput.checked = checkboxStates.get(newInput.id);
                }
            }, 2000);
        });
    });

    // Trigger Shopify filter update without modifying URL
    const form = sizeFilterContainer.closest('form');
    if (form) {
        form.dispatchEvent(new Event('change'));
        console.log('Triggered form change event for filter update');
    }
}

// Attach event listener to .aico-filter-clear
document.addEventListener('click', (event) => {
    if (event.target.classList.contains('aico-filter-clear')) {
        console.log('Clear filter clicked');
        handleClearFilters(event);
    }
});

$(document).on('click', '.aico-show-all-result-button', function () {
    $('body').removeClass('mb-filter-open');
});

$(".categories-filter-item .filter-btn").removeClass("active-filter");
$(document).on("click", ".categories-filter-item", function (event) {
  event.preventDefault();

  const $this = $(this);
  const dataHandle = $this.attr("data-title");
  const $filterBtn = $this.find(".filter-btn");

  aico.jq("#aicoCustomSortOption").show();

  // Ensure request_data is defined
  if (typeof request_data === "undefined") {
    console.error("request_data is not defined.");
    return;
  }

  // Make sure the array exists
  if (!Array.isArray(request_data["aico_c_collection"])) {
    request_data["aico_c_collection"] = [];
  }

  // Toggle the active state
  if ($filterBtn.hasClass("active-filter")) {
    // Remove active class
    $filterBtn.removeClass("active-filter");
    // Remove from array
    request_data["aico_c_collection"] = request_data["aico_c_collection"].filter(
      (item) => item !== dataHandle
    );
  } else {
    // Add active class
    $filterBtn.addClass("active-filter");
    // Add to array (avoid duplicates)
    if (!request_data["aico_c_collection"].includes(dataHandle)) {
      request_data["aico_c_collection"].push(dataHandle);
    }
  }

  // If no filters selected, reset to default
  if (request_data["aico_c_collection"].length === 0) {
    request_data["collection_handle"] = aico.collecton_handle;
    delete request_data["aico_c_collection"];
  }

  delete request_data.page;

  // Perform AJAX request
  aico.jq.ajax({
    url: aico.aico_url + "api/filter-data",
    method: "POST",
    data: request_data,
    success: function (response) {
      aico.jq(".aico-filters").removeAttr("style");
      removeParamsFromUrl();
      appendAicoParamsToUrl();
      aico.jq(".aico-tags").remove();
      tagsList(response);
      aico.jq(".collection ul#product-grid").remove();
      aico.jq(".product__grid-item").remove();
      productsAppendAfterRespons(response);
      // selectedList(request_data, response);
      aico.jq(".aico-pagination").remove();
      // makePagination(response.product_count);
      initNilePagination();
       // Sync pagination active state with URL and trigger load
        try {
          let url = new URL(window.location.href);
          let pageParam = url.searchParams.get('page');
          if (!isNaN(pageParam) && pageParam !== null) {
            paginationActive(pageParam);
            aico.jq('span.aico-pagination-item.active').trigger('click');
          } else {
            paginationActive();
          }
        } catch (e) {
          // Fallback in case URL parsing fails
          paginationActive();
        }
      selectedTagChecked(request_data);
      aico.jq(".af-filter-message").remove();
      if (response.total_product == 0) {
        aico.jq("#aicoCustomSortOption").hide();
        emptyFunctionLoad();
      }
      collectionProductDiscount(response);
      removeRefineByIflengthIsZero();
      aico.jq(".aico-metafield-value-append").html("");
      MetafiledValueFilerHtml(response);
      productOptionsFilters(response);
      onloadCheckValue(request_data);
      commonFunctionLoad(response);
      manageNileCategories(response.allow_collection)
      Object.keys(request_data).forEach(function(key) {
        if (key.startsWith('aico_nmv_')) {
            let optionType = key.replace('aico_nmv_', '');
            let values = request_data[key];

            values.forEach(function(value) {
                let selector = `input[type=checkbox][value="${value}"]`;
                aico.jq(selector).closest('.af-widget').find('.af-widget-top').addClass('af-widget-active');
                aico.jq(selector).closest('.af-widget').addClass('af-actived');
            });
        }
        if (key.startsWith('aico__nmp_')) {
            let optionType = key.replace('aico__nmp_', '');
            let values = request_data[key];
            values.forEach(function(value) {
                let selector = `input[type=checkbox][value="${value}"]`;
                aico.jq(selector).each(function() {
                    aico.jq(this).prop('checked', true);
                    aico.jq(this).closest('.af-widget').find('.af-widget-top').addClass('af-widget-active');
                    aico.jq(selector).closest('.af-widget').addClass('af-actived');
                });
            });
        }
        if (key.startsWith('aico__smv_c_')) {
            let optionType = key.replace('aico__smv_c_', '');
            let values = request_data[key];
            values.forEach(function(value) {
                let selector = `input[type=checkbox][value="${value}"]`;
                aico.jq(selector).each(function() {
                    aico.jq(this).prop('checked', true);
                    aico.jq(this).closest('.af-widget').find('.af-widget-top').addClass('af-widget-active');
                    aico.jq(selector).closest('.af-widget').addClass('af-actived');
                });
            });
        }
        if (key.startsWith('aico_option')) {
            let optionType = key.replace('aico_option', '');
            let values = request_data[key];
            values.forEach(function(value) {
                let selector = `input[type=checkbox][value="${value}"]`;
                aico.jq(selector).each(function() {
                    aico.jq(this).prop('checked', true);
                    aico.jq(this).closest('.af-widget').find('.af-widget-top').addClass('af-widget-active');
                    aico.jq(selector).closest('.af-widget').addClass('af-actived');
                });
            });
        }
    });
    },
    error: function (error) {
      console.error("AJAX request failed:", error);
    },
  });
});

  const closeFilter = ($filterDialog) => {
    isDragging = false;
    startY = 0;
    currentY = 0;
    $('body').removeClass('mb-filter-open');

    console.log('fff');

    $filterDialog.css({
      transform: 'translateY(100%)',
      opacity: 0,
      visibility: 'hidden',
      transition: 'transform 300ms ease, opacity 300ms ease'
    });

    setTimeout(() => {
      $filterDialog.removeClass('show af-mobile-view-filter-option');
      $('.aico-mb').removeClass('aico-filter-mb');
      $filterDialog.removeAttr('style');
    }, 300);
  };
  // Function to open the filter
  const openFilter = ($filterDialog) => {
    $('body').addClass('mb-filter-open');
    $filterDialog.addClass('show af-mobile-view-filter-option');
    $filterDialog.css({
      transform: 'translateY(0)',
      opacity: 1,
      visibility: 'visible',
      transition: 'transform 300ms ease, opacity 300ms ease'
    });
    $('.aico-mb').addClass('aico-filter-mb');

    let filter_count = aico.jq('.aico-filter-refine-by-items').length;
    if(filter_count > 0){
      refindMobileHtml(filter_count, window._nileFilterResultsTotal);
    }
  };

function initFilterDrag() {
  const $filterDialog = $('.aico-filters');              // container to move
  const $dragHandle   = $('.af-mb-filter-drag-button');  // element you drag
  const $filterContent = $filterDialog.find('.filters-wrap-box'); // scrollable content

  let startY = 0;
  let currentY = 0;
  let isDragging = false;

  const handleDragStart = (e) => {
    if (window.matchMedia('(max-width: 1024px)').matches) {
      if ($filterContent.scrollTop() > 0) {
        isDragging = false;
        return;
      }
      isDragging = true;
      startY = e.type.startsWith('touch') ? e.touches[0].clientY : e.clientY;
      $filterDialog.css({ transition: 'none' });
    }
  };

  const handleDragMove = (e) => {
    if (!isDragging) return;
    currentY = e.type.startsWith('touch') ? e.touches[0].clientY : e.clientY;
    const deltaY = currentY - startY;

    if (deltaY >= 0) {
      $filterDialog.css({ transform: `translateY(${deltaY}px)` });
    } else {
      $filterDialog.css({ transform: `translateY(${deltaY / 4}px)` });
    }

    e.preventDefault();
  };

  const handleDragEnd = () => {
    if (!isDragging) return;
    isDragging = false;

    const deltaY = currentY - startY;
    const threshold = $filterDialog.outerHeight() * 0.2;

    if (deltaY > threshold) {
      closeFilter($filterDialog);
    } else {
      $filterDialog.css({ transform: 'translateY(0)', transition: 'transform 300ms ease' });
    }
  };

  // Bind drag events only to the handle
  $dragHandle.on('touchstart', handleDragStart);
  $dragHandle.on('mousedown', handleDragStart);

  // Movement applied on document (so it won’t break if you move outside the handle)
  $(document).on('touchmove', handleDragMove);
  $(document).on('touchend touchcancel', handleDragEnd);
  $(document).on('mousemove', handleDragMove);
  $(document).on('mouseup', handleDragEnd);

  // Close button
  $('.product-grid-close .aico-close-icon').on('click', function(){
    closeFilter($filterDialog);
  });

  // Open button
  $('.aico-mb-button').on('click', function(){
    openFilter($filterDialog);
  });
}




function createRefineByItems(request_params) {
  let htmlOutput = "";
  // Locale-based singular/plural labels
  const localeLabels = {
    en: { color: ["Colour", "Colours"], size: ["Size", "Sizes"] },
    de: { color: ["Farbe", "Farben"], size: ["Grösse", "Grössen"] },
    it: { color: ["Colore", "Colori"], size: ["Dimensione", "Dimensioni"] },
    fr: { color: ["Couleur", "Couleurs"], size: ["Taille", "Tailles"] },
  };

  const locale = Shopify.locale in localeLabels ? Shopify.locale : "en";

  Object.keys(request_params).forEach((key) => {
    const values = request_params[key];

    if (values && Array.isArray(values) && values.length > 0) {
      if (
        !key.includes("aico__smv_c_") &&
        !key.includes("aico_option_") &&
        !key.includes("aico_nmv_") && 
        !key.includes("aico_simv_")

      )
        return;

      let displayLabel, filterKey;
      let checkRefine = false;

      if (key.includes("aico__smv_c_")) {
        const labelKey = key.split("aico__smv_c_")[1];
        checkRefine = true;
        if (
          labelKey === "farbe" ||
          labelKey === "colour" ||
          labelKey === "couleur" ||
          labelKey === "colore"
        ) {
          // Color label singular/plural based on values length
          displayLabel =
            values.length > 1
              ? localeLabels[locale].color[1]
              : localeLabels[locale].color[0];
        } else {
          displayLabel = labelKey.charAt(0).toUpperCase() + labelKey.slice(1);
        }
        filterKey = key;
      } else if (key.includes("aico_option_")) {
        let labelKey = key.split("aico_option_")[1];
        checkRefine = true;
        filterKey = key;

        if (labelKey === "size") {
          // Size label singular/plural based on values length
          displayLabel =
            values.length > 1
              ? localeLabels[locale].size[1]
              : localeLabels[locale].size[0];
        } else {
          displayLabel = labelKey.charAt(0).toUpperCase() + labelKey.slice(1);
        }
      } else if (key.includes("aico_nmv_")) {
        const label = key.split("aico_nmv_")[1];
        checkRefine = true;
        displayLabel = label.charAt(0).toUpperCase() + label.slice(1);
        filterKey = key;
      }else if (key.includes("aico_simv_")) {
        const label = key.split("aico_simv_")[1];
        checkRefine = true;
        displayLabel = label.charAt(0).toUpperCase() + label.slice(1);
        filterKey = key;
        console.log('filterKey', filterKey);
      }

      const valuesString = values.join(",");


    

      // Special handling for color values
      if (
        key === "aico__smv_c_farbe" ||
        key === "aico__smv_c_colour" ||
        key === "aico__smv_c_couleur" ||
        key === "aico__smv_c_colore"
      ) {
        const colorSpans = values
          .map(
            (color) =>
              `<span class="farbe-option-select" style="background:${color}"></span>`
          )
          .join("");
        htmlOutput += `
          <div class="aico-filter-refine-by-items">
            <div class="refine-by-item aico-filter-option-label refine-by-type" style="display:flex;">
              <span class="refine-by-option" data-filter-key="${filterKey}">${displayLabel}: </span>
              <div class="af-selected-values-color" style="margin: 0px -35px 0px 20px;">
                ${colorSpans}
              </div>
              <span class="aico-filter-clear">clear</span>
            </div>
          </div>
        `;
      } else {
        htmlOutput += `
          <div class="aico-filter-refine-by-items">
            <div class="refine-by-item aico-filter-option-label refine-by-type">
              <span class="refine-by-option" data-filter-key="${filterKey}">${displayLabel}: </span>
              <span class="refine-by-value" data-filter-value="${valuesString}">
                ${values.join(", ")}
              </span>
              <span class="aico-filter-clear">clear</span>
            </div>
          </div>
        `;
        // console.log('htmlOutput', htmlOutput);
      }
    }
  });

  // console.log('checkRefine', checkRefine = true)

  aico.jq(".aico-filter-refine-by-items").remove();
  return htmlOutput;
}

function reorderFilters() {
  const $container = $(".aico-metafield-value-append");

  if ($container.length) {
    const $productOptionsMain = $(".aico-product-options").not('.af-filter-size'); // main wrapper
    const $productOptionsSize = $(".aico-product-options.af-filter-size"); // inner size filter
    const $colorFilter = $(".aico-color-filter");
    const $nestedFilter = $(".aico-nested-metafield-variant-filter");
    const $simpleFilter = $(".aico-simple-metafield-filter");

    // Add 'af-ordered' to all
    $productOptionsMain.addClass('af-ordered');
    $productOptionsSize.addClass('af-ordered');
    $colorFilter.addClass('af-ordered');
    $nestedFilter.addClass('af-ordered');
    $simpleFilter.addClass('af-ordered');

    // Clear container first
    $container.empty();

    // Ensure inner size filter is inside the main wrapper
    if ($productOptionsMain.length && $productOptionsSize.length) {
      $productOptionsMain.empty().append($productOptionsSize);
    }

    // if (window.innerWidth > 1024) {
      // Desktop / large screens
      $container.append($productOptionsMain);
      $container.append($simpleFilter);
      $container.append($colorFilter);
      $container.append($nestedFilter);
    // } else {
    //   // Mobile / small screens
    //   $container.append($colorFilter);
    //   $container.append($productOptionsMain);
    //   $container.append($nestedFilter);
    //   $container.append($simpleFilter);
    // }
  }
}

// window.addEventListener('resize', reorderFilters);

function moveProductOptions() {
  const $productOptionsMain = aico.jq(".aico-product-options").not('.af-filter-size'); // main wrapper
  const $productOptionsSize = aico.jq(".aico-product-options.af-filter-size"); // size filter

  if ($productOptionsMain.length && $productOptionsSize.length) {
    // Ensure main wrapper contains size filter
    $productOptionsMain.empty().append($productOptionsSize);
  }

  if (window.innerWidth > 1024) {
    // Move before .aico-metafield-value-append
    aico.jq(".aico-metafield-value-append").before($productOptionsMain);
  } else {
    // Append inside .aico-filters
    aico.jq(".aico-filters").append($productOptionsMain);
  }
}


// window.addEventListener('resize', moveProductOptions);